<crnt-button
  [state]="buttonState()"
  class="w-100"
  type="submit"
  [wlAutomationId]="automationId()"
>
  <ng-content></ng-content>
</crnt-button>
